import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getTrimsComparisonUrl } from 'site-modules/shared/utils/core-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';

export function TrimsComparatorLink({
  className = null,
  vehicle: {
    make: { slug: makeSlug, name: makeName },
    model: { slug: modelSlug, name: modelName },
    year,
  },
}) {
  return (
    <Link
      className={classnames('d-inline-block text-blue-40 text-underline', className)}
      to={getTrimsComparisonUrl({ makeSlug, modelSlug, year })}
      data-tracking-id="compare_trims"
      data-tracking-value="Compare trim levels"
    >
      Compare {year} {makeName} {modelName} trim levels
    </Link>
  );
}

TrimsComparatorLink.propTypes = {
  vehicle: PropTypes.shape({
    make: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
    model: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  className: PropTypes.string,
};
